<template>
  <div class="block pb-6">
    <breadcrumb-list>
      <breadcrumb-link view="Home" label="Home" />
      <breadcrumb-link view="OrganizationDetail" :label="organization" />
      <breadcrumb-link view="APIAccessKeys" label="API Access" :active="true" />
    </breadcrumb-list>

    <section>
      <div class="container is-max-hd">
        <div class="box">
          <b-loading :is-full-page="false" v-model="loading"></b-loading>

          <div class="level">
            <div class="level-left">
              <div class="level-item">
                <div>
                  <h1 class="title is-3">API Access</h1>
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div v-if="subscription && subscription.has_api_access">
            <h2 class="title is-5">API Keys</h2>
            <b-table
              :data="apiKeys"
              striped
              hoverable
              mobile-cards
              mobile-breakpoint="1024px"
            >
              <b-table-column field="name" label="Name" v-slot="props">
                {{ props.row.name }}
              </b-table-column>
              <b-table-column field="key" label="API Key" v-slot="props">
                <span v-if="props.row.key" class="api-key-value">{{ props.row.key }}</span>
                <span v-else>-</span>
              </b-table-column>
              <b-table-column field="status" label="Status" v-slot="props">
                <span
                  class="tag"
                  :class="props.row.status === 'active' ? 'is-success is-light' : 'is-light'"
                >
                  {{ props.row.status }}
                </span>
              </b-table-column>
              <b-table-column field="created_at" label="Created" v-slot="props">
                {{ props.row.created_at | formatDate }}
              </b-table-column>
              <b-table-column v-slot="props" numeric>
                <b-button
                  v-if="props.row.key"
                  type="is-primary"
                  size="is-small"
                  outlined
                  @click="copyAPIKey(props.row.key)"
                >
                  Copy
                </b-button>
              </b-table-column>

              <template #empty>
                <section class="section has-text-centered">
                  <p>
                    Contact customer support at
                    <a href="mailto:support@quickadmit.com">support@quickadmit.com</a>
                    for your API access creation.
                  </p>
                </section>
              </template>
            </b-table>
          </div>

          <div v-else-if="!loading" class="has-text-centered py-5">
            <p class="mb-4">API Access is not enabled for this organization.</p>
            <b-button
              type="is-primary"
              tag="router-link"
              :to="{ name: 'PlanList', query: { enableFeature: 'api-access' } }"
            >
              Go to Plan
            </b-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import request from '../request';

export default {
  name: 'APIAccessKeys',
  data() {
    return {
      loading: false,
      subscription: null,
      apiKeys: [],
    };
  },
  computed: {
    ...mapGetters(['organization']),
  },
  mounted() {
    this.getSubscription();
  },
  methods: {
    getSubscription() {
      this.loading = true;
      request
        .get('/subscriptions/current')
        .then((resp) => {
          this.subscription = resp.data.subscription;
          if (this.subscription.has_api_access) {
            return this.getAPIKeys();
          }
        })
        .finally(() => (this.loading = false));
    },
    getAPIKeys() {
      return request.get('/products/api-keys').then((resp) => {
        this.apiKeys = resp.data.api_keys;
      });
    },
    copyAPIKey(key) {
      if (!navigator.clipboard) {
        return;
      }
      navigator.clipboard.writeText(key).then(() => {
        this.$buefy.toast.open({
          message: 'API key copied.',
          type: 'is-success',
        });
      });
    },
  },
};
</script>

<style scoped>
.api-key-value {
  font-family: monospace;
  word-break: break-all;
}
</style>
